import { Outlet } from 'react-router-dom';

const PLUMAA_LOGO_URL =
	'https://res.cloudinary.com/dd5pbp2tb/image/upload/v1770986600/Plumaa_H_W_hribid.png';

const PublicSessionAccessLayout = () => {
	return (
		<section className="relative flex min-h-screen w-full flex-col overflow-hidden bg-zinc-950">
			<header className="relative z-50 flex h-16 shrink-0 items-center justify-center bg-stone-900 px-4">
				<img
					src={PLUMAA_LOGO_URL}
					className="h-10 w-auto"
					alt="Logotipo Plumaa"
				/>
			</header>
			<main className="relative flex h-[calc(100vh-4rem)] min-h-0 w-full flex-1 flex-col">
				<Outlet />
			</main>
		</section>
	);
};

export { PublicSessionAccessLayout };
